import React, {Component} from 'react';
import PropTypes from 'prop-types';

import {getRandomElement} from './utils.js';
import {play} from './SoundManager.js';
import './SuccessLayer.css';

import success_1 from './assets/success/GearRing-GoodJob-V1-Green.png';
import success_2 from './assets/success/GearRing-GoodJob-V2-Green.png';
import success_3 from './assets/success/GearRing-GoodJob-V3-Green.png';
import success_4 from './assets/success/GearRing-GoodJob-V4-Green.png';
import success_5 from './assets/success/GearRing-GoodJob-V5-Green.png';

import fail_1 from './assets/success/GearRing-TryAgain-V1-1.png';
import fail_2 from './assets/success/GearRing-TryAgain-V2-1.png';
import fail_3 from './assets/success/GearRing-TryAgain-V3-1.png';

const success_images = [
    success_1,
    success_2,
    success_3,
    success_4,
    success_5,
];
const fail_images = [
    fail_1,
    fail_2,
    fail_3,
];
function get_random_image(success) {
    const images = success ? success_images : fail_images;
    return getRandomElement(images);
}
const success_sounds = [
    'success_1',
    'success_2',
    'success_3',
    'success_4',
    'success_5',
    'success_6',
    'success_7',
    'success_8',
];
const fail_sounds = [
    'fail_1',
    'fail_2',
    'fail_3',
    'fail_4',
    'fail_5',
    'fail_6',
];
function play_random_sound(success) {
    const sounds = success ? success_sounds : fail_sounds;
    play(getRandomElement(sounds));
}
export default class SuccessLayer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            src: get_random_image(props.success),
        };
    }
    componentWillReceiveProps(next_props) {
        // Choose a random image each time this layer is made visible,
        // Play a random sound each time this layer is made visible
        if (next_props.visible && !this.props.visible) {
            this.setState({
                src: get_random_image(next_props.success),
            });
            play_random_sound(next_props.success);
        }
    }
    render() {
        const {src} = this.state;
        const {visible} = this.props;
        let className = 'AppLayer SuccessLayer';
        if (!visible) className += ' SuccessLayer-hidden';

        return <img 
            className={className}
            src={src}
            alt=""
        />
    }
}
SuccessLayer.propTypes = {
    success: PropTypes.bool,
    visible: PropTypes.bool,
};


// WEBPACK FOOTER //
// ./src/SuccessLayer.js